import {
  SortDirection,
  DataTable,
} from "@transfr-inc/dashboard-components/data-table";
import { libraryColumns } from "./library.columns";

import { ZeroStateMessage } from "./zero-state-message";

import "./library.table.scss";

export const LibraryTable = ({
  data,
  responsiveStyles,
  actionMenuOptions,
  dataType,
  isMenuActionVisible,
  openActivityOrgsModal = null,
  className = "library-table",
}) => {
  const columns = libraryColumns(dataType, openActivityOrgsModal);

  const zeroStateMessage = <ZeroStateMessage />;

  return (
    <DataTable
      columns={columns}
      data={data}
      className={className}
      keyFields={["title"]}
      keyPrefix={"library-table"}
      defaultSortPropName="title"
      defaultSortDirection={SortDirection.ASCENDING}
      responsiveStyles={responsiveStyles}
      zeroStateMessage={zeroStateMessage}
      tableContentName={{ singular: "activity", plural: "activities" }}
      actionMenuOptions={actionMenuOptions}
      isMenuActionVisible={isMenuActionVisible}
      rowHeightConfig={{ large: 54, medium: 160, small: 280 }}
      virtualRowEnabled
    />
  );
};
